module.exports = "<div [class.loader-hidden]=\"!show\">\r\n  <div class=\"overlay\" *ngIf=\"show\">\r\n    <div>\r\n      <md-spinner mode=\"indeterminate\"></md-spinner>\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/UI-PROJECTS/Helpline1097-UI/src/app/loader/loader.component.html
// module id = ../../../../../src/app/loader/loader.component.html
// module chunks = 0